import React,{useEffect,useRef} from 'react';
import {useLocation} from 'react-router-dom';

export function ScrollToTop(){
  const {pathname}=useLocation();
  useEffect(()=>{window.scrollTo({top:0,left:0,behavior:'instant' in document.documentElement.style?'instant':'auto'});},[pathname]);
  return null;
}

export function PageTransition({children}){
  const {pathname}=useLocation();
  const sweep=useRef(null);
  const first=useRef(true);
  useEffect(()=>{
    if(first.current){first.current=false;return;}
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const el=sweep.current;
    if(reduced||!el||!el.animate)return;
    const ease='cubic-bezier(0.65,0,0.35,1)';
    el.style.transformOrigin='left';
    const a=el.animate([{transform:'scaleX(0)'},{transform:'scaleX(1)'}],{duration:350,easing:ease,fill:'forwards'});
    a.onfinish=()=>{el.style.transformOrigin='right';el.animate([{transform:'scaleX(1)'},{transform:'scaleX(0)'}],{duration:350,easing:ease,fill:'forwards'});};
  },[pathname]);
  return <><div ref={sweep} className="page-sweep"/>{children}</>;
}
